import { PropsWithChildren } from "react";
import { Stack } from "@fluentui/react/lib/Stack";

import { ITileProps } from ".";
import { useTileStyles } from "./UseTileStyles";

export function Tile(props: PropsWithChildren<ITileProps>): JSX.Element {
  const { children } = props;
  const styles = useTileStyles();

  return <Stack className={styles.root}>{children}</Stack>;
}
